module.exports = "data:application/octet-stream;base64,Y29uc3QgY2hhcnRqcyA9IHJlcXVpcmUoJy4uL2Rpc3QvY2hhcnQuY2pzJyk7CmNvbnN0IHtDaGFydCwgcmVnaXN0ZXJhYmxlc30gPSBjaGFydGpzOwoKQ2hhcnQucmVnaXN0ZXIoLi4ucmVnaXN0ZXJhYmxlcyk7Cgptb2R1bGUuZXhwb3J0cyA9IE9iamVjdC5hc3NpZ24oQ2hhcnQsIGNoYXJ0anMpOwo="


//////////////////
// WEBPACK FOOTER
// ./~/chart.js/auto/auto.cjs
// module id = 1198
// module chunks = 0